import { ActionFunctionArgs, LoaderFunctionArgs, redirect } from "react-router-dom";
import { getCurrentWeekRange, myAxios } from "src/components/common/functions";
import { appendField } from "../common/FilterFrame/FilterField";
import { fields } from "./TimeOffFilterForm";
import { saveAs } from "file-saver";
import { buildDefaultState } from "../common/FilterFrame/FilterModal";
import { extraFields } from "./TimeOffList";

export async function timeOffsLoader({ request }: LoaderFunctionArgs) {
    const url = new URL(request.url);
    const pageParam  = url.searchParams.get("page");
    const limitParam = url.searchParams.get("limit");
    const week = getCurrentWeekRange();
    const startParam = url.searchParams.get("createdAtFrom");
    const endParam = url.searchParams.get("createdAtTo");
    let shouldRedirect = false;
    for (const [key] of url.searchParams) {
        if(![...Object.keys(buildDefaultState(fields)), ...extraFields].includes(key)){
            url.searchParams.delete(key);
            shouldRedirect = true;
        }
    }
    if (!pageParam) {
        url.searchParams.set("page", "1");
        shouldRedirect = true;
    }
    if (!limitParam) {
        url.searchParams.set("limit", "10");
        shouldRedirect = true;
    }
    if (!startParam) {
        url.searchParams.set("createdAtFrom", week.start);
        shouldRedirect = true;
    }
    if (!endParam) {
        url.searchParams.set("createdAtTo", week.end);
        shouldRedirect = true;
    }
    if (shouldRedirect) throw redirect(url.pathname + "?" + url.searchParams.toString());
    const page  = Number(url.searchParams.get("page"));
    const limit = Number(url.searchParams.get("limit"));
    const fd = new FormData();
    fd.append("page", String(page));
    fd.append("limit", String(limit));
    for (const field of fields) {
        appendField(fd, url.searchParams, field);
    }
    const timeOffsRes = await myAxios({ fileName: "timeOffs/readTimeOffs.php", formData: fd });
    if(!timeOffsRes) throw redirect("..");
    return timeOffsRes.data;
}

export async function timeOffLoader({ params }: LoaderFunctionArgs) {
    const { id } = params;
    if (!id) {
    throw redirect(`/TimeOffs`);
    }
    const formData = new FormData();
    formData.append("id", id);
    const res = await myAxios({
        fileName: "timeOffs/readTimeOff.php",
        formData
    });
    if (!res || !res.data) throw redirect("..");
    return {
        timeOff: res.data
    };
}
const urlMap = { "Add": "timeOffs/createTimeOff.php", "Edit": "timeOffs/updateTimeOff.php" };
export async function timeOffAction({ request }: ActionFunctionArgs){
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    const action = formData.get("action");
    if(!formData.get("approverId")){
        window.alert("The approver is not selected.");
        return;
    }
    if(!formData.get("requesterId")){
        window.alert("Please select requester.");
        return;
    }
    const url = urlMap[action as keyof typeof urlMap];
    if(!url){
        window.alert("Invalid Keyword");
        return;
    }
    const res = await myAxios({ fileName: url, formData: formData, signal: controller.signal });
    if(!res) return;
    if(action === "Add"){
        return redirect(`/Organizations/${res.data.id}`);
    }
    throw redirect("..");
}

export async function deleteTimeOffAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    if(!formData.get("id")){
        throw new Response("Missing id", { status: 400 });
    }
    const res = await myAxios({
        fileName: "timeOffs/deleteTimeOff.php",
        formData: formData, 
        signal: controller.signal
    });
    if(!res) throw redirect("..");
    throw redirect("../..");
}

export async function voidTimeOffAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    if(!formData.get("id")){
        throw new Response("Missing id", { status: 400 });
    }
    await myAxios({
        fileName: "timeOffs/voidTimeOff.php",
        formData: formData, 
        signal: controller.signal
    });
    throw redirect("..");
}

export async function validateTimeOffAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    if(!formData.get("id")){
        throw new Response("Missing id", { status: 400 });
    }
    await myAxios({
        fileName: "timeOffs/validateTimeOff.php",
        formData: formData, 
        signal: controller.signal
    });
    throw redirect("..");
}

export async function notifyTimeOffAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    if(!formData.get("id")){
        throw new Response("Missing id", { status: 400 });
    }
    await myAxios({
        fileName: "/timeOffs/notifyTimeOff.php",
        formData: formData, 
        signal: controller.signal
    });
    throw redirect("..");
}

export async function approveTimeOffAction({ request }: ActionFunctionArgs){
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    if(!formData.get("id")){
        throw new Response("Missing id", { status: 400 });
    }
    await myAxios({
        fileName: "/timeOffs/approveTimeOff.php",
        formData: formData, 
        signal: controller.signal
    });
    throw redirect("..");
}
export async function timeOffExportAction({ request }: ActionFunctionArgs){
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const url = new URL(request.url);
    const formData = await request.formData();
    for(const field of fields){
        appendField(formData, url.searchParams, field);
    }
    const res = await myAxios({
        fileName: `/timeOffs/exportTimeOffs.php`,
        formData, 
        responseType: "blob", 
        signal: controller.signal
    });
    if(!res) throw redirect(`..?${url.searchParams.toString()}`);
    const disposition = res.headers["content-disposition"];
    let filename = "Time Offs.xlsx";
    if (disposition) {
        const match = disposition.match(/filename="?(.+?)"?$/);
        if (match) filename = decodeURIComponent(match[1]);
    }
    saveAs(
        new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        filename
    );
    throw redirect(`..?${url.searchParams.toString()}`);
}